import { service } from 'services';
import {
  _t,
  setToken,
  clearToken,
  getParam,
  dispatchPendingAction,
  setKey,
  clearKey,
} from 'utils';
import { Notification } from 'models';
import { NOTIFICATION_TYPE } from 'constant';
import { getDispatch } from 'redux/store';
import { ACTIONS_TYPES } from '../helper';

export default {
  login: async ({
    email, password, history,
  }) => {
    const dispatch = getDispatch();

    dispatchPendingAction({ action: ACTIONS_TYPES.IDENTITY.LOGIN });
    clearToken();
    clearKey('isReseller');
    setKey('isAccessByDCD', false);

    const response = await service.identity.login({ email, password });
    const { httpStatus = null, items = [] } = response;

    if (httpStatus) {
      dispatch({
        type: ACTIONS_TYPES.COMMON.QUICK_UPDATE,
        payload: {
          notifications: [Notification({
            type: NOTIFICATION_TYPE.ERROR,
            action: ACTIONS_TYPES.IDENTITY.LOGIN,
            message: _t('Wrong email or password, Please try again.'),
          })],
          pendingActions: [],
        },
      });
    } else {
      const token = btoa(`${email}:${password}`);
      let jwtToken;

      try {
        const tokenResponse = await service.identity.getJwtToken({ token });
        if (tokenResponse.token) {
          jwtToken = tokenResponse.token;
        }
      } catch (e) {
        jwtToken = '';
      }

      setToken({ token, type: 'basic' });
      setToken({ token: jwtToken, type: 'jwt' });

      if (items.length > 1) {
        setKey('isReseller', true);
        const [item = {}] = items;
        const { properties = {} } = item;
        const { contractNumber } = properties;
        setKey('selectedContractId', contractNumber);
        history.push('/contracts');
      } else {
        setKey('isReseller', false);
        const [item = {}] = items;
        const { properties = {} } = item;
        const { contractNumber } = properties;
        setKey('selectedContractId', contractNumber);
        const returnUrl = getParam('return-url');
        history.push(returnUrl || '/data-centers');
      }

      dispatch({
        type: ACTIONS_TYPES.IDENTITY.LOGIN,
        payload: {},
      });
    }
  },
};
